import CryptoJS from "crypto-js";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

const secretKey = "my-very-secret-key";

const ProtectedRoute = ({ children }) => {
  const encrypted = sessionStorage.getItem("isAuthorized");

  let isAuthorized = false;

  useEffect(() => {
    return () => sessionStorage.clear();
  }, []);

  if (encrypted) {
    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      isAuthorized = decrypted === "true";
    } catch (error) {
      console.error("Decryption error", error);
    }
  }

  if (!isAuthorized) {
    return <Navigate to="/welcome" replace />;
  }

  return children;
};

export default ProtectedRoute;
